import { Injectable } from '@angular/core';
import { EQimaAvatarSize } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaAvatarService {
  public readonly avatarSize = EQimaAvatarSize;
}
